import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';



export default function (props) {
	const { t, i18n } = useTranslation("",{lng: props.language});
  	let navigate = useNavigate(); 
	
	const callUrl = (url) => {
		navigate(url);
		window.scrollTo(0, 0);
	};

  	return (
		  	<>		
				<section class="about">	 
					<Grid container style={{paddingTop: "40px"}}>
				    	<Grid item xs={12}>
						<Grid container spacing={2}>
						        		<Grid item xs={2}>
							     	   </Grid>
						        		<Grid item xs={8}>
											<Box sx={{paddingTop: "0px", backgroundColor: "#fff"}}>
												<h2>{t("AboutReimoHeadline")}</h2>
												<h3>{t("AboutReimoDescription")}</h3>	
											</Box>	
							     	   	</Grid>
						        		<Grid item xs={2}>
							     	   </Grid>
						     	   </Grid>
					     	   </Grid>
				     	   	</Grid>					
						
			  	</section>
		  </>
	  )
}